import * as React from 'react'
// import { Link } from "gatsby"

const HeroHome = () => (
  <div id='hero-index' className='hero-div hero-cover hero-info-left'>
    <div className='hero-info shadow-sm rounded'>
      <h1>
        Conoce el nuevo catálogo de productos <span>Amerex</span>
      </h1>
      <p>
        Productos y servicios para prevenir y controlar incendios en su hogar,
        vehículo o negocio de la marca #1 de artículos contra el fuego
        reconocida mundialmente. Equipos para bomberos, extintores portátiles y
        unidades con ruedas para mayor capacidad de extinción.
      </p>
      <a
        className='btn btn-lg btn-danger'
        target='_blank'
        rel='noopener noreferrer'
        href='https://www.server.amerex.mx/pdf/product-catalog-spanish.pdf'
      >
        Descargar catálogo de portátiles
      </a>
    </div>
  </div>
)

export default HeroHome
